import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { media, layout } from '@prisjakt/ui-base';

const ellipsisWrapperMinWidth = 0;
const sharedStyleBreadcrumbs = css`
  display: flex;
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.secondary};
  line-height: 1.2;
  min-width: ${ellipsisWrapperMinWidth};
`;

type InnerProps = {
  mobile?: boolean;
  desktop?: boolean;
};

export const Breadcrumbs = styled.div<InnerProps>(
  ({ mobile, desktop }) => css`
    display: none;
    margin: 0 ${layout.measurements.spacing050};
    margin-top: ${layout.measurements.spacing050};
    align-items: center;

    ${media.smallOnly`
      display: ${mobile ? 'flex' : 'none'};
    `}

    ${media.mediumUp`
       display: ${desktop ? 'flex' : 'none'};
       font-size: ${layout.measurements.fontSizeNormal};
    `}
  `
);

export const Crumb = styled(Link).attrs({ 'data-test': 'Crumb' })`
  align-items: center;
  font-weight: 400;
  ${sharedStyleBreadcrumbs};

  &:hover {
    color: ${p => p.theme.text.linkExternal};
  }
`;

export const Current = styled.span.attrs({
  'data-test': 'Crumb',
  'data-test-type': 'current',
})`
  ${sharedStyleBreadcrumbs};
  color: ${p => p.theme.text.quaternary};
`;

export const Ellipsis = styled.span`
  display: inline;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.5;
`;

export const ArrowStyles = css<InnerProps>(
  ({ theme }) => css`
    display: flex;
    font-size: ${layout.measurements.fontSizeNormal};
    margin-right: ${layout.measurements.spacing025};
    margin-left: ${layout.measurements.spacing025};

    ${media.smallOnly`
      margin-left: 0px;
    `}

    && {
      path {
        fill: ${theme.text.secondary};
      }
    }
  `
);
